import React, { Component } from 'react';

//styles
import './sectionThree.scss';
import '../../static/fonts/opensanshebrew/stylesheet.css';
import Slider from '../Slider/Slider';
import Data from '../../data/galleryData.json';
import { isMobile, isIos } from '../../static/helper';
import TrackVisibility from 'react-on-screen';


const Arrow = (props) => {
    if(props.isVisible) props.onArrowShown();
    return (
        <div className={props.isVisible ? "slider-arrow active" : "slider-arrow"}>
            <span></span>
        </div>
    )
}

class SectionThree extends Component {
    constructor() {
        super();
        this.setOwlRef = this.setOwlRef.bind(this);
        this.state = {
            data: [],
            OwlRef: null
        }
    }
    onArrowShown(){
        setTimeout(() => {
            document.querySelector(".slider-arrow").style.opacity = 0;
        }, 4000);
    }
    setNavBar(e) {
        const index = e.item.index === 0 ? 1 : e.item.index <= 12 ? e.item.index - 5 : e.item.index - 12 - 5;
        const isMobileDevice = (isMobile() || isIos());
        const heights = {
            mobile: {
                close: {
                    section: "131.7188vw",
                    slider: "90.71875vw"
                },
                open: {
                    section: "284vw",
                    slider: "206.25vw"
                }
            },
            desktop: {
                close: {
                    section: "42.7083vw"
                },
                open: {
                    section: "70.30208vw"
                }
            }
        }
        if (index === 1) {
            document.querySelector("#section3").style.height = isMobileDevice !== null ? heights.mobile.close.section : heights.desktop.close.section;
            document.querySelector(".slider").style.height = isMobileDevice !== null ? heights.mobile.close.slider : "";
        }
        else {
            document.querySelector("#section3").style.height = isMobileDevice !== null ? heights.mobile.open.section : heights.desktop.open.section;;
            document.querySelector(".slider").style.height = isMobileDevice !== null ? heights.mobile.open.slider : "";
        }
    }

    setOwlRef(ref) {
        this.setState({
            OwlRef: ref
        })
    }

    componentDidMount() {
        const elements = [];
        Data.map((item, index) => {
            elements.push(
                <div id={`item${index + 1}`} key={index} className="item">
                    <div className="year">{item.year}</div>
                    <div className={`image image-${index + 1}`}>
                        <div className="inner-text">
                            <div className="inner-title">{item.title}</div>
                            <div className="date">{item.date}</div>
                        </div>
                    </div>
                    <div className="text">{item.desc}</div>
                </div>
            );
        });
        this.setState({
            data: elements
        })
    }

    render() {
        return (
            <div id="section3" className="section3-container" >
                <div className="image"></div>
                < div className="desc-container" >
                    <div className="title">סיפורה של מהפכה</div>
                    {this.state.data.length > 0 ?
                        <div className="slider">
                            <Slider setOwlRef={this.setOwlRef} setNavBar={this.setNavBar}>
                                {this.state.data}
                            </Slider>
                        </div>
                        : ""
                    }
                    <TrackVisibility partialVisibility once>
                        <Arrow onArrowShown={this.onArrowShown} />
                    </TrackVisibility>


                </div >
                <div className="line"></div>
            </div >
        );
    }
}

export default SectionThree;


// WEBPACK FOOTER //
// ./src/Components/SectionThree/SectionThree.js